import {
  OFFLINE,
  OK,
  UN_AUTHENTICATE,
} from '../../common/components/containers/RequestsStatusProvider/Statuses';
import setRequestsStatus from '../clientGraphql/data/setRequestsStatus.graphql';

const UNAUTHENTICATED_ERROR_CODE = 401;
const FAILED_TO_FETCH = 'Failed to fetch';

const onError = storeProvider => async ({ graphQLErrors, networkError }) => {
  if (
    graphQLErrors &&
    graphQLErrors.some(
      ({ statusCode }) => statusCode === UNAUTHENTICATED_ERROR_CODE,
    )
  ) {
    await storeProvider.apolloClient.mutate({
      mutation: setRequestsStatus,
      variables: { status: UN_AUTHENTICATE },
    });
  } else if (networkError?.message === FAILED_TO_FETCH) {
    await storeProvider.apolloClient.mutate({
      mutation: setRequestsStatus,
      variables: { status: OFFLINE },
    });
  } else {
    await storeProvider.apolloClient.mutate({
      mutation: setRequestsStatus,
      variables: { status: OK },
    });
  }
};

const cleanTypename = variables =>
  variables
    ? JSON.parse(JSON.stringify(variables), (key, value) =>
        key === '__typename' ? undefined : value,
      )
    : variables;

export const buildRequestSubscriber = storeProvider => ({
  onRequest: ({ operation }) => {
    operation.variables = cleanTypename(operation.variables);
  },
  onSuccess: () => {
    // do nothing
  },
  onError: onError(storeProvider),
  onCancel: () => {
    // do nothing
  },
});
export default buildRequestSubscriber;
